import { useIntl } from 'react-intl';
import { useMemo } from 'react';
import metricTexts from 'i18n/metric';
import { MetricPerformanceFactor } from 'constants/scorecards';

interface PerformanceFactorOption {
  id: MetricPerformanceFactor;
  name: string;
  tooltipWithIcon: React.ReactNode;
}

const usePerformanceFactorOptions = (): PerformanceFactorOption[] => {
  const { formatMessage } = useIntl();

  return useMemo(
    () => [
      {
        id: MetricPerformanceFactor.PRORATED,
        name: formatMessage(metricTexts.prorated),
        tooltipWithIcon: formatMessage(metricTexts.proratedInfo, {
          br: <br />,
        }),
      },
      {
        id: MetricPerformanceFactor.PIPELINE,
        name: formatMessage(metricTexts.pipeline),
        tooltipWithIcon: formatMessage(metricTexts.pipelineInfo, {
          br: <br />,
        }),
      },
      {
        id: MetricPerformanceFactor.EXCELLENCE,
        name: formatMessage(metricTexts.excellence),
        tooltipWithIcon: formatMessage(metricTexts.excellenceInfo, {
          br: <br />,
        }),
      },
      {
        id: MetricPerformanceFactor.REVENUE_NO,
        name: formatMessage(metricTexts.revenueNo),
        tooltipWithIcon: formatMessage(metricTexts.revenueNoInfo, {
          br: <br />,
        }),
      },
      {
        id: MetricPerformanceFactor.REVENUE_EX,
        name: formatMessage(metricTexts.revenueEx),
        tooltipWithIcon: formatMessage(metricTexts.revenueExInfo, {
          br: <br />,
        }),
      },
      {
        id: MetricPerformanceFactor.DM,
        name: formatMessage(metricTexts.dm),
        tooltipWithIcon: formatMessage(metricTexts.dmInfo, { br: <br /> }),
      },
      {
        id: MetricPerformanceFactor.BILLABILITY,
        name: formatMessage(metricTexts.billability),
        tooltipWithIcon: formatMessage(metricTexts.billabilityInfo, {
          br: <br />,
        }),
      },
      {
        id: MetricPerformanceFactor.INVERSE_PROPORTION,
        name: formatMessage(metricTexts.inverseProportion),
        tooltipWithIcon: formatMessage(metricTexts.inverseProportionInfo, {
          br: <br />,
        }),
      },
    ],
    [formatMessage],
  );
};

export default usePerformanceFactorOptions;
